var _path, _g, _g2, _g3, _g4, _g5, _g6, _path2, _path3, _path4, _g7, _g8, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 284,
    viewBox: "0 0 309 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.564 265C208.739 265 257.524 216.215 257.524 155.824C257.524 95.434 208.524 46.6489 148.564 46.6489C88.3882 46.6489 39.6031 95.434 39.6031 155.824C39.6031 216.215 88.3882 265 148.564 265Z",
    fill: "#F3F1FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.859,
    y: 54.6714,
    width: 22.3749,
    height: 22.3749,
    rx: 11.1875,
    transform: "rotate(30 253.859 54.6714)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.879,
    y: 54.7478,
    width: 22.263,
    height: 22.263,
    rx: 11.1315,
    transform: "rotate(30 253.879 54.7478)",
    stroke: "black",
    strokeWidth: 0.111875,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.235 74.0425L253.715 67.8719C253.287 66.1339 254.413 64.3395 256.16 63.9761C257.893 63.6156 259.513 64.8151 259.692 66.592L259.722 66.8907L259.996 66.7674C261.625 66.0343 263.473 66.8373 264.028 68.5187C264.586 70.2134 263.596 72.0858 261.876 72.584L255.772 74.3527C255.535 74.4216 255.294 74.2827 255.235 74.0425Z",
    fill: "#FE9A79",
    stroke: "#0B0C0E",
    strokeWidth: 0.279686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.914,
    y: 32.7349,
    width: 14.7623,
    height: 14.7623,
    rx: 7.38115,
    transform: "rotate(-15 261.914 32.7349)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.959,
    y: 32.761,
    width: 14.6885,
    height: 14.6885,
    rx: 7.34424,
    transform: "rotate(-15 261.959 32.761)",
    stroke: "black",
    strokeWidth: 0.0738115,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.593 41.1304L268.005 38.9608C266.994 38.3498 266.683 36.9873 267.328 36.0027C267.969 35.0259 269.284 34.8298 270.197 35.5751L270.35 35.7004L270.42 35.5151C270.838 34.4134 272.075 33.9255 273.118 34.4513C274.169 34.9812 274.581 36.317 274.011 37.3516L271.989 41.0244C271.91 41.1674 271.733 41.2148 271.593 41.1304Z",
    fill: "#FEBBA5",
    stroke: "#0B0C0E",
    strokeWidth: 0.184529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.0504,
    y: 63.46,
    width: 13.87,
    height: 13.87,
    rx: 6.93502,
    transform: "rotate(15 48.0504 63.46)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.0749,
    y: 63.5024,
    width: 13.8007,
    height: 13.8007,
    rx: 6.90035,
    transform: "rotate(15 48.0749 63.5024)",
    stroke: "black",
    strokeWidth: 0.0693502,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9821 74.8384L50.0819 71.3875C49.5466 70.4156 49.933 69.1605 50.9208 68.6626C51.9008 68.1686 53.0631 68.627 53.4556 69.6621L53.5216 69.8362L53.6657 69.7184C54.5232 69.0182 55.759 69.2024 56.3607 70.1202C56.9672 71.0453 56.6743 72.3254 55.7247 72.8995L52.3536 74.938C52.2224 75.0173 52.0561 74.9727 51.9821 74.8384Z",
    fill: "#FEBBA5",
    stroke: "#0B0C0E",
    strokeWidth: 0.173376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.679,
    y: 232.268,
    width: 28.8226,
    height: 28.8226,
    rx: 14.4113,
    transform: "rotate(30 64.679 232.268)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7053,
    y: 232.366,
    width: 28.6785,
    height: 28.6785,
    rx: 14.3392,
    transform: "rotate(30 64.7053 232.366)",
    stroke: "black",
    strokeWidth: 0.144113,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4513 257.221L64.493 249.272C63.9414 247.033 65.392 244.722 67.6426 244.254C69.8752 243.789 71.9619 245.335 72.1929 247.624L72.2317 248.008L72.5844 247.85C74.6821 246.905 77.0636 247.94 77.7777 250.105C78.4976 252.289 77.2212 254.701 75.0064 255.342L67.1434 257.621C66.8374 257.709 66.5275 257.53 66.4513 257.221Z",
    fill: "#FE9A79",
    stroke: "#0B0C0E",
    strokeWidth: 0.360282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_319_14582)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.551,
    y: 57.6045,
    width: 69.1453,
    height: 45.0644,
    rx: 5.64452,
    transform: "rotate(-46.915 164.551 57.6045)",
    fill: "url(#paint0_linear_319_14582)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.579,
    y: 50.1037,
    width: 56.5965,
    height: 2.75473,
    transform: "rotate(-46.915 174.579 50.1037)",
    fill: "#FCDEB1",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.753,
    y: 51.635,
    width: 56.5965,
    height: 2.75473,
    transform: "rotate(43.085 167.753 51.635)",
    fill: "#FCDEB1",
    stroke: "black",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 164.692,
    y: 57.5998,
    width: 68.9454,
    height: 44.8644,
    rx: 5.54354,
    transform: "rotate(-46.915 164.692 57.5998)",
    stroke: "black",
    strokeWidth: 0.2,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.348 55.539C169.418 55.2136 170.439 56.1687 170.186 57.2582L168.959 62.5374C168.706 63.6269 167.368 64.0338 166.551 63.2697L162.593 59.5674C161.776 58.8033 162.092 57.4414 163.162 57.116L168.348 55.539Z",
    fill: "url(#paint1_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.0656607
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.377 55.9849C170.307 56.3103 169.286 55.3552 169.539 54.2657L170.766 48.9865C171.019 47.897 172.357 47.4902 173.174 48.2542L177.132 51.9565C177.949 52.7206 177.633 54.0825 176.562 54.408L171.377 55.9849Z",
    fill: "url(#paint2_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.0656607
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-1_319_14582",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.788 56.4396C176.783 56.4603 176.767 56.4769 176.747 56.4831L175.587 56.8359C175.258 56.9358 175.161 57.3536 175.412 57.588L176.298 58.4164C176.313 58.4309 176.32 58.4525 176.315 58.4732C176.308 58.5051 176.276 58.525 176.244 58.5176L170.551 57.1943C170.311 57.1386 170.162 56.899 170.217 56.6592L170.515 55.378C170.571 55.1382 170.81 54.989 171.05 55.0448L176.743 56.3679C176.775 56.3754 176.795 56.4075 176.788 56.4396Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.788 56.4396C176.783 56.4603 176.767 56.4769 176.747 56.4831L175.587 56.8359C175.258 56.9358 175.161 57.3536 175.412 57.588L176.298 58.4164C176.313 58.4309 176.32 58.4525 176.315 58.4732C176.308 58.5051 176.276 58.525 176.244 58.5176L170.551 57.1943C170.311 57.1386 170.162 56.899 170.217 56.6592L170.515 55.378C170.571 55.1382 170.81 54.989 171.05 55.0448L176.743 56.3679C176.775 56.3754 176.795 56.4075 176.788 56.4396Z",
    fill: "url(#paint3_linear_319_14582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.244 58.5176L176.259 58.4536L176.244 58.5176ZM176.298 58.4164L176.343 58.3684L176.298 58.4164ZM176.747 56.4831L176.728 56.4203L176.747 56.4831ZM175.587 56.8359L175.568 56.7731L175.587 56.8359ZM175.606 56.8988L176.766 56.546L176.728 56.4203L175.568 56.7731L175.606 56.8988ZM176.343 58.3684L175.457 57.54L175.367 57.636L176.253 58.4644L176.343 58.3684ZM176.259 58.4536L170.566 57.1304L170.536 57.2583L176.229 58.5815L176.259 58.4536ZM170.281 56.6741L170.579 55.3929L170.451 55.3632L170.153 56.6443L170.281 56.6741ZM171.035 55.1087L176.728 56.4319L176.758 56.304L171.065 54.9808L171.035 55.1087ZM176.728 56.4319C176.725 56.4311 176.723 56.4279 176.724 56.4247L176.852 56.4544C176.867 56.387 176.825 56.3197 176.758 56.304L176.728 56.4319ZM170.579 55.3929C170.627 55.1884 170.831 55.0612 171.035 55.1087L171.065 54.9808C170.79 54.9169 170.515 55.0881 170.451 55.3632L170.579 55.3929ZM170.566 57.1304C170.361 57.0828 170.234 56.8786 170.281 56.6741L170.153 56.6443C170.089 56.9195 170.261 57.1943 170.536 57.2583L170.566 57.1304ZM176.251 58.4583C176.252 58.4549 176.255 58.4528 176.259 58.4536L176.229 58.5815C176.296 58.5972 176.363 58.5553 176.379 58.4881L176.251 58.4583ZM176.253 58.4644C176.251 58.4628 176.25 58.4605 176.251 58.4583L176.379 58.4881C176.389 58.4445 176.375 58.399 176.343 58.3684L176.253 58.4644ZM176.766 56.546C176.809 56.5329 176.841 56.498 176.852 56.4544L176.724 56.4247C176.724 56.4226 176.726 56.4209 176.728 56.4203L176.766 56.546ZM175.568 56.7731C175.191 56.8877 175.08 57.367 175.367 57.636L175.457 57.54C175.243 57.3402 175.326 56.9839 175.606 56.8988L175.568 56.7731Z",
    fill: "black",
    mask: "url(#path-21-inside-1_319_14582)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-2_319_14582",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.821 62.8191C170.841 62.8129 170.857 62.7963 170.862 62.7755L171.136 61.5945C171.214 61.2602 171.624 61.1354 171.875 61.3698L172.761 62.1982C172.776 62.2127 172.798 62.2178 172.819 62.2116C172.85 62.2021 172.868 62.1689 172.858 62.1375L171.158 56.5456C171.086 56.3101 170.837 56.1772 170.601 56.2488L169.343 56.6315C169.107 56.7032 168.975 56.9522 169.046 57.1877L170.747 62.7794C170.756 62.8109 170.79 62.8287 170.821 62.8191Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.821 62.8191C170.841 62.8129 170.857 62.7963 170.862 62.7755L171.136 61.5945C171.214 61.2602 171.624 61.1354 171.875 61.3698L172.761 62.1982C172.776 62.2127 172.798 62.2178 172.819 62.2116C172.85 62.2021 172.868 62.1689 172.858 62.1375L171.158 56.5456C171.086 56.3101 170.837 56.1772 170.601 56.2488L169.343 56.6315C169.107 56.7032 168.975 56.9522 169.046 57.1877L170.747 62.7794C170.756 62.8109 170.79 62.8287 170.821 62.8191Z",
    fill: "url(#paint4_linear_319_14582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.761 62.1982L172.806 62.1502L172.761 62.1982ZM170.862 62.7755L170.798 62.7607L170.862 62.7755ZM171.136 61.5945L171.072 61.5796L171.136 61.5945ZM171.875 61.3698L171.92 61.3219L171.875 61.3698ZM171.2 61.6093L170.926 62.7904L170.798 62.7607L171.072 61.5796L171.2 61.6093ZM172.716 62.2461L171.83 61.4178L171.92 61.3219L172.806 62.1502L172.716 62.2461ZM172.795 62.1566L171.095 56.5647L171.22 56.5265L172.921 62.1184L172.795 62.1566ZM170.62 56.3117L169.362 56.6944L169.324 56.5687L170.582 56.186L170.62 56.3117ZM169.109 57.1686L170.809 62.7603L170.684 62.7985L168.983 57.2068L169.109 57.1686ZM170.809 62.7603C170.808 62.7571 170.805 62.7553 170.802 62.7563L170.84 62.8819C170.774 62.902 170.704 62.8647 170.684 62.7985L170.809 62.7603ZM169.362 56.6944C169.161 56.7554 169.048 56.9678 169.109 57.1686L168.983 57.2068C168.901 56.9366 169.054 56.6509 169.324 56.5687L169.362 56.6944ZM171.095 56.5647C171.034 56.3639 170.821 56.2506 170.62 56.3117L170.582 56.186C170.852 56.1038 171.138 56.2563 171.22 56.5265L171.095 56.5647ZM172.799 62.1488C172.796 62.1498 172.794 62.1533 172.795 62.1566L172.921 62.1184C172.941 62.1845 172.904 62.2544 172.838 62.2744L172.799 62.1488ZM172.806 62.1502C172.804 62.1487 172.802 62.1482 172.799 62.1488L172.838 62.2744C172.795 62.2874 172.748 62.2767 172.716 62.2461L172.806 62.1502ZM170.926 62.7904C170.916 62.834 170.883 62.8689 170.84 62.8819L170.802 62.7563C170.8 62.7569 170.798 62.7586 170.798 62.7607L170.926 62.7904ZM171.072 61.5796C171.161 61.1961 171.632 61.0529 171.92 61.3219L171.83 61.4178C171.616 61.2179 171.267 61.3243 171.2 61.6093L171.072 61.5796Z",
    fill: "black",
    mask: "url(#path-23-inside-2_319_14582)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.163,
    y: 55.9643,
    width: 3.68627,
    height: 3.68627,
    rx: 1.45308,
    transform: "rotate(-46.915 167.163 55.9643)",
    fill: "#F7AD3C",
    stroke: "black",
    strokeWidth: 0.0656607
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.861 49.1071L212.639 53.6214L208.042 49.3219L212.954 44.0693L216.822 47.6865C217.225 48.0633 217.242 48.6994 216.861 49.1071ZM205.767 59.5047L201.901 55.8882L206.814 50.6356L211.41 54.9351L207.188 59.4494C206.807 59.8571 206.17 59.8815 205.767 59.5047ZM206.941 37.3376L205.559 38.8159C205.394 38.3922 205.144 37.9948 204.79 37.663C203.523 36.4785 201.527 36.5453 200.342 37.8125C198.93 39.322 199.134 41.2277 199.64 42.6957C198.142 42.2887 196.227 42.212 194.815 43.7215C193.63 44.9887 193.696 46.9853 194.963 48.1698C195.317 48.5016 195.731 48.7233 196.165 48.8596L194.782 50.3379C194.409 50.7367 194.576 51.5008 195.157 52.0443L198.308 54.9911C198.888 55.5338 199.663 55.6502 200.036 55.2514L200.588 54.6607L205.501 49.4081L200.248 44.4946L201.476 43.1809L206.73 48.0943L211.642 42.8417L212.195 42.2511C212.568 41.8522 212.399 41.0882 211.819 40.5455L208.668 37.5986C208.087 37.0552 207.315 36.9387 206.941 37.3376ZM203.625 40.8835L201.688 42.9548C201.163 41.8824 200.604 40.1658 201.656 39.0415C202.164 38.4981 203.019 38.4688 203.562 38.9762C204.105 39.4844 204.134 40.3401 203.625 40.8835ZM198.099 46.7925C197.591 47.3358 196.735 47.3645 196.192 46.8563C195.649 46.3489 195.621 45.4939 196.129 44.9505C197.181 43.8262 198.931 44.2683 200.036 44.7212L198.099 46.7925Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.639 53.6214L212.587 53.6766L212.642 53.7282L212.694 53.673L212.639 53.6214ZM216.861 49.1071L216.806 49.0555L216.861 49.1071ZM208.042 49.3219L207.986 49.2702L207.935 49.3255L207.99 49.3771L208.042 49.3219ZM212.954 44.0693L213.006 44.0141L212.951 43.9624L212.899 44.0176L212.954 44.0693ZM216.822 47.6865L216.77 47.7417L216.822 47.6865ZM201.901 55.8882L201.846 55.8366L201.794 55.8918L201.849 55.9434L201.901 55.8882ZM206.814 50.6356L206.865 50.5804L206.81 50.5288L206.758 50.584L206.814 50.6356ZM211.41 54.9351L211.466 54.9868L211.517 54.9315L211.462 54.8799L211.41 54.9351ZM205.559 38.8159L205.488 38.8433L205.532 38.9552L205.614 38.8675L205.559 38.8159ZM199.64 42.6957L199.62 42.7687L199.758 42.8061L199.712 42.6711L199.64 42.6957ZM196.165 48.8596L196.22 48.9113L196.302 48.8235L196.188 48.7875L196.165 48.8596ZM195.157 52.0443L195.209 51.989L195.157 52.0443ZM198.308 54.9911L198.257 55.0464L198.308 54.9911ZM205.501 49.4081L205.556 49.4597L205.608 49.4045L205.553 49.3529L205.501 49.4081ZM200.248 44.4946L200.192 44.443L200.141 44.4982L200.196 44.5498L200.248 44.4946ZM201.476 43.1809L201.528 43.1256L201.473 43.074L201.421 43.1292L201.476 43.1809ZM206.73 48.0943L206.678 48.1495L206.733 48.2012L206.785 48.146L206.73 48.0943ZM201.688 42.9548L201.62 42.9881L201.669 43.0865L201.743 43.0064L201.688 42.9548ZM198.099 46.7925L198.044 46.7409L198.099 46.7925ZM200.036 44.7212L200.091 44.7728L200.166 44.6928L200.065 44.6512L200.036 44.7212ZM212.694 53.673L216.916 49.1587L216.806 49.0555L212.583 53.5697L212.694 53.673ZM207.99 49.3771L212.587 53.6766L212.69 53.5662L208.093 49.2667L207.99 49.3771ZM212.899 44.0176L207.986 49.2702L208.097 49.3735L213.01 44.1209L212.899 44.0176ZM216.873 47.6312L213.006 44.0141L212.903 44.1245L216.77 47.7417L216.873 47.6312ZM216.916 49.1587C217.325 48.7212 217.307 48.0372 216.873 47.6312L216.77 47.7417C217.142 48.0894 217.159 48.6776 216.806 49.0555L216.916 49.1587ZM201.849 55.9434L205.716 59.5599L205.819 59.4494L201.952 55.833L201.849 55.9434ZM206.758 50.584L201.846 55.8366L201.956 55.9399L206.869 50.6873L206.758 50.584ZM211.462 54.8799L206.865 50.5804L206.762 50.6908L211.359 54.9903L211.462 54.8799ZM207.244 59.501L211.466 54.9868L211.355 54.8835L207.133 59.3977L207.244 59.501ZM205.716 59.5599C206.15 59.9657 206.834 59.9386 207.244 59.501L207.133 59.3977C206.78 59.7755 206.191 59.7972 205.819 59.4494L205.716 59.5599ZM206.886 37.286L205.504 38.7642L205.614 38.8675L206.997 37.3892L206.886 37.286ZM205.629 38.7884C205.461 38.3556 205.205 37.9482 204.841 37.6078L204.738 37.7182C205.083 38.0413 205.327 38.4289 205.488 38.8433L205.629 38.7884ZM204.841 37.6078C203.544 36.3948 201.501 36.4631 200.287 37.7608L200.397 37.8641C201.554 36.6274 203.502 36.5623 204.738 37.7182L204.841 37.6078ZM200.287 37.7608C198.846 39.3012 199.059 41.2428 199.569 42.7204L199.712 42.6711C199.209 41.2127 199.014 39.3428 200.397 37.8641L200.287 37.7608ZM199.66 42.6228C198.152 42.2131 196.201 42.1295 194.76 43.6699L194.871 43.7732C196.254 42.2945 198.132 42.3643 199.62 42.7687L199.66 42.6228ZM194.76 43.6699C193.547 44.9676 193.614 47.012 194.911 48.225L195.014 48.1146C193.778 46.9587 193.714 45.0099 194.871 43.7732L194.76 43.6699ZM194.911 48.225C195.275 48.5655 195.699 48.7925 196.142 48.9317L196.188 48.7875C195.763 48.6541 195.36 48.4376 195.014 48.1146L194.911 48.225ZM196.11 48.808L194.727 50.2862L194.838 50.3895L196.22 48.9113L196.11 48.808ZM194.727 50.2862C194.519 50.5091 194.467 50.8279 194.538 51.1531C194.61 51.4786 194.806 51.8186 195.106 52.0995L195.209 51.989C194.928 51.7264 194.75 51.4127 194.686 51.1207C194.622 50.8282 194.673 50.5656 194.838 50.3895L194.727 50.2862ZM195.106 52.0995L198.257 55.0464L198.36 54.9359L195.209 51.989L195.106 52.0995ZM198.257 55.0464C198.556 55.3268 198.909 55.4995 199.238 55.5491C199.568 55.5986 199.883 55.5259 200.091 55.303L199.981 55.1997C199.816 55.3757 199.557 55.4442 199.261 55.3996C198.965 55.355 198.64 55.1981 198.36 54.9359L198.257 55.0464ZM200.091 55.303L200.643 54.7123L200.533 54.609L199.981 55.1997L200.091 55.303ZM200.643 54.7123L205.556 49.4597L205.446 49.3564L200.533 54.609L200.643 54.7123ZM205.553 49.3529L200.299 44.4394L200.196 44.5498L205.449 49.4633L205.553 49.3529ZM200.303 44.5463L201.532 43.2325L201.421 43.1292L200.192 44.443L200.303 44.5463ZM201.425 43.2361L206.678 48.1495L206.781 48.0391L201.528 43.1256L201.425 43.2361ZM206.785 48.146L211.698 42.8934L211.587 42.7901L206.675 48.0427L206.785 48.146ZM211.698 42.8934L212.25 42.3027L212.14 42.1994L211.587 42.7901L211.698 42.8934ZM212.25 42.3027C212.459 42.0798 212.51 41.761 212.438 41.4359C212.367 41.1105 212.171 40.7707 211.871 40.4903L211.767 40.6007C212.048 40.8629 212.226 41.1765 212.291 41.4685C212.355 41.7609 212.304 42.0234 212.14 42.1994L212.25 42.3027ZM211.871 40.4903L208.72 37.5434L208.617 37.6538L211.767 40.6007L211.871 40.4903ZM208.72 37.5434C208.42 37.2626 208.068 37.0897 207.738 37.04C207.409 36.9903 207.095 37.0631 206.886 37.286L206.997 37.3892C207.161 37.2132 207.42 37.1448 207.716 37.1895C208.011 37.2341 208.336 37.3912 208.617 37.6538L208.72 37.5434ZM203.57 40.8318L201.633 42.9032L201.743 43.0064L203.681 40.9351L203.57 40.8318ZM201.756 42.9215C201.495 42.389 201.228 41.7009 201.156 41.0097C201.083 40.3196 201.205 39.6341 201.711 39.0931L201.601 38.9898C201.055 39.5732 200.93 40.3082 201.005 41.0255C201.081 41.7418 201.356 42.4482 201.62 42.9881L201.756 42.9215ZM201.711 39.0931C202.191 38.5802 202.998 38.5526 203.51 39.0314L203.613 38.921C203.04 38.385 202.137 38.4161 201.601 38.9898L201.711 39.0931ZM203.51 39.0314C204.023 39.511 204.05 40.319 203.57 40.8318L203.681 40.9351C204.217 40.3613 204.187 39.4577 203.613 38.921L203.51 39.0314ZM198.044 46.7409C197.564 47.2537 196.756 47.2807 196.243 46.8011L196.14 46.9115C196.714 47.4482 197.617 47.418 198.154 46.8442L198.044 46.7409ZM196.243 46.8011C195.731 46.3223 195.705 45.5151 196.185 45.0022L196.074 44.8989C195.538 45.4726 195.567 46.3755 196.14 46.9115L196.243 46.8011ZM196.185 45.0022C196.691 44.4612 197.366 44.2939 198.06 44.32C198.754 44.3461 199.459 44.5663 200.007 44.7911L200.065 44.6512C199.508 44.4233 198.785 44.1959 198.065 44.1689C197.345 44.1418 196.62 44.3155 196.074 44.8989L196.185 45.0022ZM199.981 44.6695L198.044 46.7409L198.154 46.8442L200.091 44.7728L199.981 44.6695Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_319_14582",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 36,
    width: 25,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.861 49.1071L212.639 53.6214L208.042 49.3219L212.954 44.0693L216.822 47.6865C217.225 48.0633 217.242 48.6994 216.861 49.1071ZM205.767 59.5047L201.901 55.8882L206.814 50.6356L211.41 54.9351L207.188 59.4494C206.807 59.8571 206.17 59.8815 205.767 59.5047ZM206.941 37.3376L205.559 38.8159C205.394 38.3922 205.144 37.9948 204.79 37.663C203.523 36.4785 201.527 36.5453 200.342 37.8125C198.93 39.322 199.134 41.2277 199.64 42.6957C198.142 42.2887 196.227 42.212 194.815 43.7215C193.63 44.9887 193.696 46.9853 194.963 48.1698C195.317 48.5016 195.731 48.7233 196.165 48.8596L194.782 50.3379C194.409 50.7367 194.576 51.5008 195.157 52.0443L198.308 54.9911C198.888 55.5338 199.663 55.6502 200.036 55.2514L200.588 54.6607L205.501 49.4081L200.248 44.4946L201.476 43.1809L206.73 48.0943L211.642 42.8417L212.195 42.2511C212.568 41.8522 212.399 41.0882 211.819 40.5455L208.668 37.5986C208.087 37.0552 207.315 36.9387 206.941 37.3376ZM203.625 40.8835L201.688 42.9548C201.163 41.8824 200.604 40.1658 201.656 39.0415C202.164 38.4981 203.019 38.4688 203.562 38.9762C204.105 39.4844 204.134 40.3401 203.625 40.8835ZM198.099 46.7925C197.591 47.3358 196.735 47.3645 196.192 46.8563C195.649 46.3489 195.621 45.4939 196.129 44.9505C197.181 43.8262 198.931 44.2683 200.036 44.7212L198.099 46.7925Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.164,
    y: 48.1455,
    width: 26.3724,
    height: 26.3724,
    transform: "rotate(-46.915 186.164 48.1455)",
    fill: "#E8F7EE"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_319_14582)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.852,
    y: 184.375,
    width: 69.1453,
    height: 45.0644,
    rx: 5.64452,
    transform: "rotate(13.085 226.852 184.375)",
    fill: "url(#paint5_linear_319_14582)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.839 197.198L260.493 204.809L267.934 206.539L260.898 209.513L261.552 217.124L256.549 211.352L249.513 214.326L253.457 207.784L248.454 202.011L255.894 203.74L259.839 197.198Z",
    fill: "#FEF7EB",
    stroke: "#0B0C0E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.639 227.9C245.172 227.792 244.785 227.613 244.48 227.364C244.175 227.115 243.953 226.821 243.813 226.48C243.681 226.135 243.636 225.768 243.679 225.381L244.477 225.567C244.468 225.962 244.578 226.309 244.81 226.609C245.043 226.903 245.377 227.1 245.812 227.201C246.136 227.277 246.433 227.267 246.702 227.172C246.972 227.071 247.198 226.904 247.382 226.673C247.572 226.444 247.705 226.17 247.778 225.852C247.896 225.345 247.848 224.903 247.635 224.525C247.422 224.147 247.088 223.905 246.633 223.799C246.257 223.712 245.916 223.721 245.61 223.828C245.305 223.935 245.059 224.111 244.872 224.355L244.093 224.174L245.546 220.569L249.121 221.4L248.956 222.111L246.014 221.427L245.133 223.409C245.332 223.257 245.583 223.151 245.884 223.091C246.192 223.033 246.525 223.045 246.882 223.128C247.33 223.232 247.695 223.426 247.978 223.711C248.268 223.998 248.465 224.341 248.57 224.742C248.676 225.143 248.675 225.571 248.57 226.025C248.469 226.46 248.281 226.841 248.007 227.167C247.739 227.495 247.4 227.728 246.992 227.866C246.59 228.005 246.139 228.017 245.639 227.9ZM251.74 229.318C251.246 229.204 250.852 229.016 250.556 228.756C250.262 228.489 250.048 228.176 249.912 227.816C249.783 227.457 249.715 227.075 249.706 226.669C249.706 226.259 249.753 225.852 249.846 225.449C250.021 224.696 250.278 224.061 250.618 223.544C250.958 223.021 251.36 222.646 251.824 222.418C252.295 222.186 252.81 222.134 253.369 222.264C253.797 222.364 254.145 222.533 254.411 222.773C254.677 223.013 254.864 223.296 254.973 223.623C255.09 223.944 255.131 224.282 255.097 224.637L254.337 224.46C254.351 224.073 254.259 223.751 254.059 223.492C253.859 223.233 253.57 223.06 253.194 222.973C252.681 222.854 252.192 222.997 251.729 223.402C251.273 223.803 250.913 224.513 250.648 225.533C250.875 225.264 251.183 225.058 251.572 224.916C251.969 224.769 252.408 224.751 252.888 224.863C253.278 224.953 253.62 225.129 253.916 225.389C254.217 225.651 254.437 225.972 254.574 226.353C254.713 226.728 254.731 227.136 254.629 227.577C254.54 227.96 254.36 228.305 254.09 228.612C253.821 228.919 253.481 229.141 253.073 229.279C252.671 229.419 252.227 229.432 251.74 229.318ZM251.849 228.584C252.154 228.655 252.442 228.653 252.712 228.579C252.983 228.505 253.212 228.371 253.402 228.175C253.592 227.973 253.722 227.722 253.792 227.424C253.899 226.963 253.832 226.56 253.59 226.217C253.356 225.868 253.012 225.641 252.557 225.535C252.252 225.464 251.963 225.472 251.689 225.559C251.417 225.64 251.183 225.78 250.985 225.981C250.795 226.183 250.668 226.42 250.604 226.693C250.536 226.985 250.543 227.264 250.626 227.53C250.716 227.79 250.866 228.013 251.076 228.199C251.286 228.385 251.543 228.513 251.849 228.584ZM258.079 230.792C257.475 230.652 256.987 230.384 256.613 229.989C256.247 229.589 256.009 229.099 255.897 228.519C255.787 227.932 255.814 227.288 255.977 226.587C256.14 225.885 256.399 225.299 256.755 224.827C257.113 224.349 257.543 224.015 258.046 223.823C258.557 223.627 259.115 223.6 259.718 223.74C260.322 223.88 260.807 224.15 261.173 224.55C261.54 224.944 261.778 225.434 261.888 226.02C262 226.601 261.974 227.242 261.811 227.943C261.648 228.644 261.388 229.234 261.03 229.712C260.674 230.184 260.244 230.518 259.74 230.716C259.237 230.907 258.683 230.932 258.079 230.792ZM258.247 230.071C258.643 230.163 259.023 230.135 259.386 229.987C259.757 229.833 260.078 229.569 260.35 229.195C260.63 228.815 260.838 228.333 260.974 227.748C261.109 227.164 261.135 226.643 261.049 226.185C260.971 225.728 260.798 225.353 260.531 225.058C260.272 224.758 259.945 224.563 259.549 224.47C259.146 224.377 258.762 224.407 258.398 224.562C258.035 224.711 257.714 224.971 257.436 225.345C257.157 225.718 256.95 226.197 256.814 226.781C256.679 227.366 256.653 227.89 256.736 228.355C256.821 228.812 256.994 229.191 257.252 229.491C257.513 229.784 257.844 229.978 258.247 230.071Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226.927,
    y: 184.496,
    width: 68.9454,
    height: 44.8644,
    rx: 5.54354,
    transform: "rotate(13.085 226.927 184.496)",
    stroke: "black",
    strokeWidth: 0.2,
    shapeRendering: "crispEdges"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.194 158.805C72.647 151.956 114.583 114.118 147.837 80.0107C156.988 112.493 177.033 183.906 185.221 213.7C174.805 208.142 86.7878 191.283 43.9469 201.039C43.5421 199.708 30.7115 189.795 32.194 158.805Z",
    fill: "url(#paint6_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.317 154.764C148.099 173.777 156.348 190.069 165.008 201.039C169.337 206.524 173.767 210.675 178.037 213.172C182.307 215.668 186.41 216.506 190.096 215.385C193.782 214.264 196.723 211.284 198.881 206.833C201.038 202.382 202.407 196.468 202.95 189.501C204.035 175.567 201.818 157.441 196.036 138.427C190.254 119.414 182.004 103.122 173.345 92.152C169.015 86.6666 164.586 82.516 160.316 80.0194C156.045 77.5228 151.943 76.6851 148.257 77.8061C144.571 78.9271 141.629 81.9069 139.472 86.3581C137.314 90.8095 135.946 96.7233 135.403 103.691C134.317 117.624 136.535 135.75 142.317 154.764Z",
    fill: "url(#paint7_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7603 240.157C40.0122 231.474 40.2577 220.566 39.0451 208.21L28.4545 209.249C28.3145 214.527 32.2263 228.825 36.4767 242.802C37.1423 242.599 40.5308 241.787 48.7603 240.157Z",
    fill: "url(#paint8_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0754 208.635L41.6466 200.648L21.1981 201.55L23.8926 210.41L44.0754 208.635Z",
    fill: "#FD784C",
    stroke: "black",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0674 178.876C21.7414 184.38 19.0581 190.053 14.1 191.561C9.14187 193.069 3.7547 189.85 2.08073 184.346C0.406758 178.841 3.09006 173.169 8.04816 171.661C13.0063 170.153 18.3934 173.371 20.0674 178.876Z",
    fill: "#FE9A79",
    stroke: "black",
    strokeWidth: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71081 160.19C15.0061 159.67 32.1939 158.806 32.1939 158.806L43.9468 201.039L19.7707 204.029C19.7707 204.029 13.0449 196.258 9.79285 181.978C7.97124 175.988 8.44989 170.389 9.71081 160.19Z",
    fill: "url(#paint9_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M162.239 135.64L136.348 127.836C136.969 140.189 145.303 165.876 152.059 179.499L168.785 157.167L162.239 135.64Z",
    fill: "url(#paint10_linear_319_14582)",
    stroke: "black",
    strokeWidth: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.453 145.248C169.37 148.263 169.823 151.092 169.823 153.224C169.823 154.292 169.708 155.165 169.494 155.793C169.277 156.43 168.985 156.74 168.683 156.832C168.381 156.924 167.966 156.829 167.431 156.42C166.904 156.018 166.323 155.357 165.728 154.469C164.54 152.699 163.342 150.096 162.425 147.081C161.509 144.066 161.055 141.237 161.055 139.105C161.056 138.036 161.17 137.164 161.384 136.536C161.601 135.898 161.893 135.589 162.195 135.497C162.497 135.405 162.912 135.5 163.447 135.908C163.974 136.311 164.555 136.972 165.15 137.859C166.338 139.63 167.536 142.233 168.453 145.248Z",
    fill: "#D1EFDD",
    stroke: "black",
    strokeWidth: 0.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.439,
    cy: 146.164,
    rx: 1.5,
    ry: 4.5,
    transform: "rotate(-16.915 165.439 146.164)",
    fill: "#696677"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_319_14582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 104.144,
    width: 52.0493,
    height: 52.0493,
    rx: 26.0247,
    transform: "rotate(-16.915 221 104.144)",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.162,
    y: 104.231,
    width: 51.7891,
    height: 51.7891,
    rx: 25.8945,
    transform: "rotate(-16.915 221.162 104.231)",
    stroke: "black",
    strokeWidth: 0.260247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_319_14582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.097 132.587L243.198 125.365C239.565 123.331 238.306 118.566 240.464 115.021C242.606 111.503 247.218 110.657 250.521 113.176L251.077 113.599L251.303 112.938C252.645 109.007 256.947 107.142 260.684 108.872C264.451 110.615 266.058 115.274 264.172 118.987L257.478 132.167C257.217 132.68 256.599 132.868 256.097 132.587Z",
    fill: "#FD561F",
    stroke: "#0B0C0E",
    strokeWidth: 0.650616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_319_14582",
    x: 233.99,
    y: 50.3307,
    width: 47.9276,
    height: 47.9274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.34073
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.34073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_319_14582",
    x: 256.186,
    y: 26.0502,
    width: 29.5356,
    height: 29.5356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.86389
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.86389
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_319_14582",
    x: 39.0789,
    y: 60.7692,
    width: 27.7505,
    height: 27.7505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.69079
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69079
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_319_14582",
    x: 39.0845,
    y: 226.676,
    width: 61.7388,
    height: 61.7389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.59158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.59158
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_319_14582",
    x: 149.028,
    y: -0.656117,
    width: 111.189,
    height: 112.327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.7611
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.7611
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_319_14582",
    x: 161.281,
    y: 47.5686,
    width: 17.1623,
    height: 17.5012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.557218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.408626
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_319_14582",
    x: 201.127,
    y: 176.614,
    width: 108.597,
    height: 90.5932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.7611
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.7611
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_319_14582",
    x: 200.805,
    y: 78.9024,
    width: 105.332,
    height: 105.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.0976
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0976
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_14582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_14582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_14582",
    x1: 228.42,
    y1: 63.5214,
    x2: 166.343,
    y2: 100.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75CE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47BE79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_14582",
    x1: 166.737,
    y1: 64.6824,
    x2: 161.699,
    y2: 57.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00217859,
    stopColor: "#F9BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_14582",
    x1: 172.988,
    y1: 46.8415,
    x2: 178.026,
    y2: 54.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00217859,
    stopColor: "#F9BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_14582",
    x1: 176.02,
    y1: 56.5661,
    x2: 171.643,
    y2: 54.9092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_319_14582",
    x1: 170.896,
    y1: 62.0443,
    x2: 168.95,
    y2: 57.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_319_14582",
    x1: 261.425,
    y1: 184.375,
    x2: 261.425,
    y2: 229.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BD63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_319_14582",
    x1: 92.136,
    y1: 113.06,
    x2: 102.141,
    y2: 200.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367323,
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD561F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_319_14582",
    x1: 200.537,
    y1: 153.312,
    x2: 117.301,
    y2: 178.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD561F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_319_14582",
    x1: 45.5677,
    y1: 222.859,
    x2: 33.712,
    y2: 228.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD561F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_319_14582",
    x1: 45.0001,
    y1: 124.5,
    x2: 27.0001,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#FDEFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FCDEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD784C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_319_14582",
    x1: 168.5,
    y1: 137,
    x2: 146.5,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40768,
    stopColor: "#FDEFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD784C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4249,
    height: 13.4249,
    fill: "white",
    transform: "translate(255.497 60.7842) rotate(30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.85738,
    height: 8.85738,
    fill: "white",
    transform: "translate(265.53 34.8228) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.32203,
    height: 8.32203,
    fill: "white",
    transform: "translate(50.0118 66.8574) rotate(15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.2936,
    height: 17.2936,
    fill: "white",
    transform: "translate(66.7889 240.142) rotate(30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.551,
    y: 57.6045,
    width: 69.1453,
    height: 45.0644,
    rx: 5.64354,
    transform: "rotate(-46.915 164.551 57.6045)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.852,
    y: 184.375,
    width: 69.1453,
    height: 45.0644,
    rx: 5.64354,
    transform: "rotate(13.085 226.852 184.375)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(248.603 192.533) rotate(13.085)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_319_14582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2296,
    height: 31.2296,
    fill: "white",
    transform: "translate(233.988 111.075) rotate(-16.915)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.a3c3de5abf6364520663217657434a17.svg";
export { ForwardRef as ReactComponent };